import React, { useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import { useParking } from "./context";

const ParkingBookingForm = () => {
    const { hidePromoCode } = useParking();
    const formRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            parkingDetailsSubmitted: "1",
            progressToNextStep: "1",
            lang: "en-gb",
            terminalid: "0",
            entryDate: new Date(),
            entryTime: new Date(),
            exitDate: new Date(),
            exitTime: new Date(),
        },
    });

    const onSubmit = (data) => {
        setIsLoading(true);
        setTimeout(() => {
            formRef.current?.submit();
        }, 1000);
    };

    return (
        <form
            ref={formRef}
            action="https://book.glasgowprestwick.com/book/PIK/Parking"
            method="POST"
            className="parking-booking-form"
            onSubmit={handleSubmit(onSubmit)}
        >
            <input type="hidden" {...register("parkingDetailsSubmitted")} />
            <input type="hidden" {...register("progressToNextStep")} />
            <input type="hidden" {...register("lang")} />
            <input type="hidden" {...register("terminalid")} />
            <div className="field__outer">
                <div className="field__wrapper">
                    <label htmlFor="entryDate">Entry Date</label>
                    <Controller
                        name="entryDate"
                        control={control}
                        render={({ field }) => (
                            <DatePicker
                                {...field}
                                selected={field.value}
                                onChange={(date) => field.onChange(date)}
                                dateFormat="dd/MM/yyyy"
                                required
                                minDate={new Date()}
                                placeholderText="DD/MM/YYYY"
                            />
                        )}
                    />
                </div>
                <div className="field__wrapper">
                    <label htmlFor="entryTime">Entry Time</label>
                    <Controller
                        control={control}
                        name="entryTime"
                        render={({ field }) => (
                            <DatePicker
                                {...field}
                                required
                                onChange={(date) => field.onChange(date)}
                                selected={field.value}
                                showTimeSelect
                                placeholderText="00:00"
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption="Time"
                                dateFormat="HH:mm"
                            />
                        )}
                    />
                </div>
                <div className="field__wrapper">
                    <label htmlFor="exitDate">Exit Date</label>
                    <Controller
                        control={control}
                        name="exitDate"
                        render={({ field }) => (
                            <DatePicker
                                {...field}
                                required
                                selected={field.value}
                                onChange={(date) => field.onChange(date)}
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                                placeholderText="DD/MM/YYYY"
                            />
                        )}
                    />
                </div>
                <div className="field__wrapper">
                    <label htmlFor="exitTime">Exit Time</label>
                    <Controller
                        control={control}
                        name="exitTime"
                        render={({ field }) => (
                            <DatePicker
                                {...field}
                                required
                                onChange={(date) => field.onChange(date)}
                                selected={field.value}
                                showTimeSelect
                                placeholderText="00:00"
                                showTimeSelectOnly
                                timeIntervals={15}
                                dateFormat="HH:mm"
                            />
                        )}
                    />
                </div>
                {!hidePromoCode && (
                    <div className="field__wrapper wrapper__promo">
                        <label htmlFor="promocodes">Promo Codes</label>
                        <input
                            type="text"
                            {...register("promocodes")}
                            placeholder="Enter Promo..."
                        />
                    </div>
                )}
            </div>
            <div className={`btn__submit ${isLoading ? "loading" : ""}`}>
                <input
                    type="submit"
                    value={isLoading ? "" : "Book Parking"}
                    className="btn-default"
                />
            </div>
        </form>
    );
};

export default ParkingBookingForm;
